module.exports = __webpack_public_path__ + "img/30_23.92c95fe3.png";